import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";
import { useUserSubscriptionAccountQuery } from "../../../api/features/user-subscription/useUserSubscriptionAccount.query";
import {
  BONUSX_SUBSCRIPTION_TIERS,
  GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP,
} from "../../services/user-subscription/enums/bonusx-subscription-tiers.enum";
import { userSubscriptionService } from "../../services/user-subscription/user-subscription.instance";
import { getTranslationKeyForSubscriptionTier } from "./use-current-user-subscription-tier.functions";
import type { UseCurrentUserSubscriptionTierOutput } from "./use-current-user-subscription-tier.interface";

/** @deprecated Use `useUserSubscriptionTierQuery` from `src/api/features/user-subscription/` instead. */
export function useCurrentUserSubscriptionTier(): UseCurrentUserSubscriptionTierOutput {
  const isLogged = useIsLogged();
  const { account, isLoading, revalidate } = useUserSubscriptionAccountQuery();

  const currentUserTierOrFree = (isLogged ? account?.subscriptionTier : undefined) ?? BONUSX_SUBSCRIPTION_TIERS.FREE;

  const currentUserTierTranslationKey = getTranslationKeyForSubscriptionTier(
    GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTierOrFree]
  );
  const currentUserTierRenewalFrequency = userSubscriptionService.getRenewalFrequencyFromSubscriptionProviderCode(
    account?.providerCode
  );

  return {
    currentUserTier: currentUserTierOrFree,
    translationKeyForTier: currentUserTierTranslationKey,
    currentUserTierFrequency: currentUserTierRenewalFrequency,
    discounts: account?.discounts ?? [],
    currentUserTierStartDate: account?.startDate,
    currentUserTierEndDate: account?.endDate,
    planScheduledCancellationDate: account?.cancelledAt,
    isLoading,
    revalidate,
  };
}
